import {Component} from "@angular/core";
import {Store} from "../../../../../services/store.service";

@Component({
  selector: "status-wrapper",
  templateUrl: "./status-wrapper.component.html",
})
export class StatusWrapperComponent {

  public hideContent: boolean = true;
  public isStatusTabOpened = false;

  constructor(public store: Store) {}

  public openAdd() {
    this.store.state.common.sections.active = true;
    this.store.state.common.sections.type = "status";
  }

  public openStatus(openedOrClosed: any) {
    this.isStatusTabOpened = openedOrClosed;
  }
}
